import React from 'react';

import chevronDown from 'images/chevron_down_icon.svg';

import { SCOPE_ARTICLES, SCOPE_DIRECTORY, SCOPE_FORUM } from '../../hooks/useSearchResults';
import { search_page_path } from '../../routes';
import styles from './styles.module.scss';

const TAB_NAMES = [SCOPE_ARTICLES, SCOPE_FORUM, SCOPE_DIRECTORY];

const SearchTabs = ({ query, scope }) => {
  const handleTabChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    window.location.href = search_page_path({
      query,
      scope: e.target.value,
    });
  };
  return (
    <>
      <div className="search-scope-tabs">
        {TAB_NAMES.map((tab) => (
          <a
            key={tab}
            href={search_page_path({ query, scope: tab })}
            className={`tab-control ${scope === tab && '--red'}`}
          >
            {tab}
          </a>
        ))}
      </div>
      <div className={styles.mobileTabSection}>
        <select
          className={styles.mobileTabs}
          defaultValue={scope}
          id="tab-names"
          name="tab-names"
          onChange={handleTabChange}
        >
          {TAB_NAMES.map((tab) => (
            <option key={tab} value={tab}>
              {tab}
            </option>
          ))}
        </select>
        <img src={chevronDown} width="10" className={styles.chevronDown} />
      </div>
    </>
  );
};

export default SearchTabs;
